import styled from 'styled-components'
import star from 'resources/svg/icons/star-empty.svg'
import starFull from 'resources/svg/icons/star.svg'
import { link } from 'app/sofia/resources/theme/css'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .react-rater {
    display: flex;
    align-items: center;
    line-height: normal;

    > * {
      display: inline-block;
    }
  }

  .react-rater-star {
    margin: 0 2px 0 0;
    position: relative;
    width: 16px;
    height: 16px;
    color: transparent;
    background-image: url(${star});
    background-size: 16px;
    background-repeat: no-repeat;
    text-indent: -99999px;

    &.is-active,
    &.will-be-active {
      background-image: url(${starFull});
    }

    &.will-be-active {
      cursor: pointer;
    }
  }

  span {
    ${link};
    color: ${props => props.theme.palette.general.strong};
    cursor: pointer;
    margin-left: 10px;
  }
`
